import { css } from "@emotion/react";
import type { ReactNode } from "react";
import { TooltipV2 } from "src/components/TooltipV2/TooltipV2.tsx";
import { InfoOutlinedIcon } from "src/lib/ui-icon-v2";

/**
 * «(?)» с пояснением — как у полей формы (InputLabel), но для заголовков,
 * переключателей и строк карточки, где поля ввода нет.
 */
export const HelpHint = ({ text }: { text: ReactNode }) =>
  text ? (
    <TooltipV2 cursor={"help"} content={text}>
      <span css={icon} aria-label={typeof text === "string" ? text : undefined}>
        <InfoOutlinedIcon />
      </span>
    </TooltipV2>
  ) : null;

/** Подпись и «(?)» в одну строку. */
export const WithHint = ({
  children,
  hint,
}: {
  children: ReactNode;
  hint: ReactNode;
}) => (
  <span css={row}>
    {children}
    <HelpHint text={hint} />
  </span>
);

const icon = css`
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
`;

const row = css`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;
